/* eslint-disable no-case-declarations */
import { actionCreator } from 'utils';
import * as TranslationTypes from '../types/translationTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    offset: 0,
    limit: 10,

    submittingTranslationTag: false,
    translationTagPopup: false,

    sort: {
        key: 'created_at',
        type: 'desc',
    },
    resellers: {
        loading: false,
        error: false,
        listing: null,
        selected: undefined,
    },
    products: {
        loading: false,
        error: false,
        selected: 'CARRIER',
    },
    add: {
        loading: false,
        error: false,
        success: false,
        current: 0,
    },
    edit: {
        loading: false,
        data: null,
        error: false,
        success: false,
        source: null,
    },
    filters: {
        name: '',
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case TranslationTypes.LOAD_TRANSLATIONS:
        return Object.assign({}, state, {
            loading: true,
            error: false,
        });

    case actionCreator(TranslationTypes.LOAD_TRANSLATIONS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(TranslationTypes.LOAD_TRANSLATIONS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case TranslationTypes.SET_RESELLER_FOR_TRANSLATIONS:
        return Object.assign({}, state, {
            resellers: Object.assign({}, state.resellers, {
                selected: action.id,
            }),
        });

    case TranslationTypes.SET_PRODUCT_FOR_TRANSLATIONS:
        return Object.assign({}, state, {
            listing: [],
            products: Object.assign({}, state.products, {
                selected: action.name,
            }),
        });

    case TranslationTypes.SET_TRANSLATION_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.value,
        });

    case TranslationTypes.SET_TRANSLATION_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case TranslationTypes.LOAD_EDITABLE_TRANSLATION:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(TranslationTypes.LOAD_EDITABLE_TRANSLATION, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(TranslationTypes.LOAD_EDITABLE_TRANSLATION, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: true,
            }),
        });

    case TranslationTypes.SET_SOURCE:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                source: action.payload,
            }),
        });

    case TranslationTypes.ADD_NEW_TRANSLATION:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(TranslationTypes.ADD_NEW_TRANSLATION, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: action.loading,
                error: false,
                success: action.success,
            }),
        });

    case actionCreator(TranslationTypes.ADD_NEW_TRANSLATION, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: false,
                error: action.error,
            }),
        });

    case TranslationTypes.SET_EMPTY_EDITABLE_TRANSLATIONS:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: null,
                error: false,
            }),
        });

    case TranslationTypes.EDIT_TRANSLATIONS:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(TranslationTypes.EDIT_TRANSLATIONS, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                success: action.success,
            }),
        });

    case actionCreator(TranslationTypes.EDIT_TRANSLATIONS, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: true,
            }),
        });

    case TranslationTypes.RESET_TRANSLATION_PRODUCT_PAGINATION_LIST:
        return Object.assign({}, state, {
            offset: 0,
        });

    case TranslationTypes.SET_TRANSLATION_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(TranslationTypes.SET_TRANSLATION_FILTER, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case TranslationTypes.RESET_TRANSLATION_FILTERS:
        return Object.assign({}, state, {
            filters: initState.filters,
        });

    case TranslationTypes.SET_TRANSLATION_TAG_POPUP:
        return Object.assign({}, state, {
            translationTagPopup: action.data,
        });

    case TranslationTypes.ADD_TRANSLATION_TAG:
        return Object.assign({}, state, {
            submittingTranslationTag: true,
        });

    case actionCreator(TranslationTypes.ADD_TRANSLATION_TAG, 'res'):
        return Object.assign({}, state, {
            submittingTranslationTag: false,
            translationTagPopup: false,
        });

    case actionCreator(TranslationTypes.ADD_TRANSLATION_TAG, 'err'):
        return Object.assign({}, state, {
            submittingTranslationTag: false,
            translationTagPopup: false,
        });

    case TranslationTypes.EDIT_TRANSLATION_TAG:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                ...state.edit,
                loading: true,
                error: false,
            }),
        });

    case actionCreator(TranslationTypes.EDIT_TRANSLATION_TAG, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                ...state.edit,
                loading: false,
                success: true,
            }),
        });

    case actionCreator(TranslationTypes.EDIT_TRANSLATION_TAG, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                ...state.edit,
                loading: false,
                error: true,
            }),
        });

    default:
        return state;
    }
}
